/* eslint-disable jsx-a11y/anchor-is-valid,no-script-url */
import * as React from "react";
import { TabNames } from "./props";

export interface CustomProps {
  tabName: TabNames;
  tabChangeHandler: (tabName: TabNames) => void;
}

const Tabs: React.FunctionComponent<CustomProps> = (props) => {
  const [tabName, setTabName] = React.useState<TabNames>(
    props.tabName || TabNames.GeneralInfo
  );
  const setElementActive = (tabValue: TabNames) => {
    setTabName(tabValue);
    props.tabChangeHandler(tabValue);
  };

  return (
    <ul
      className="nav tab-underline mb-4 border-bottom font-normal font-weight-semibold flex-nowrap text-nowrap overflow-auto px-md-0 px-3 w-100"
      id="activity-tab"
      role="tablist"
    >
      <li className="nav-item pr-4 mr-2" role="presentation">
        <a
          className={`cursor-pointer nav-link position-relative px-0 py-2  ${
            tabName === TabNames.GeneralInfo ? "active" : ""
          }`}
          onClick={(e) => setElementActive(TabNames.GeneralInfo)}
        >
          <span className=" py-1 d-inline-flex text-gray-900">
            General Info
          </span>
        </a>
      </li>

      <li className="nav-item pr-4 mr-2" role="presentation">
        <a
          className={`cursor-pointer nav-link position-relative px-0 py-2  ${
            tabName === TabNames.AttributeInfo ? "active" : ""
          }`}
          onClick={(e) => setElementActive(TabNames.AttributeInfo)}
        >
          <span className=" py-1 d-inline-flex text-gray-900">
            Attribute Info
          </span>
        </a>
      </li>
      <li className="nav-item pr-4 mr-2" role="presentation">
        <a
          className={`cursor-pointer nav-link position-relative px-0 py-2  ${
            tabName === TabNames.AmenitiesTab ? "active" : ""
          }`}
          onClick={(e) => setElementActive(TabNames.AmenitiesTab)}
        >
          <span className=" py-1 d-inline-flex text-gray-900">Amenities </span>
        </a>
      </li>
      <li className="nav-item pr-4 mr-2" role="presentation">
        <a
          className={`cursor-pointer nav-link position-relative px-0 py-2  ${
            tabName === TabNames.People ? "active" : ""
          }`}
          onClick={(e) => setElementActive(TabNames.People)}
        >
          <span className=" py-1 d-inline-flex text-gray-900">People </span>
        </a>
      </li>
    </ul>
  );
};

export default Tabs;
